import React from "react";
import {SiteContext} from '../layouts/Main'

function FormModal({
  src,
  buttonType = "solid",
  buttonLabel = "Launch Form",
  height = 550,
  type,
}) {

  const siteContext = React.useContext(SiteContext)

  React.useEffect(() => {
    if (siteContext.modalShow) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteContext.modalShow]);
  if (!src && !type){
    throw new Error("Invalid formModal config. Type or src must be defined.");    
  }
  var targetURL = src;
  if(type === "contact"){
    targetURL = `${process.env.GATSBY_SF_DOMAIN}/ContactUs`
  }
  if (type === "demo"){
    targetURL = `${process.env.GATSBY_SF_DOMAIN}/ContactUsDemo`
  }
  if (!targetURL) return <></>;
  return (
    <>
      <button
        className={`button ${buttonType}`}
        onClick={(e) => {
          e.preventDefault();
          siteContext.setModalHeight(height);
          siteContext.setModalSrc(targetURL);
          siteContext.setModalShow(true);
        }}
      >
        {buttonLabel}
      </button>
    </>
  );
}

export default FormModal;
